<div class="container incoming-session-card" *ngIf="Visits && Visits.length && this.app.getUserData() && IsSessionInTime">
  <i class="fa fa-bell bell"></i>
  <h5>
    {{ CounterText }}
  </h5>
  <!-- {{ printSlot(Slot) }} -->
  <div class="buttons-group" *ngIf="Visits">
    <button (click)="startSessionById(this?.Visits[0]?.id,this?.Visits[0]?.hcp?.id,this?.Visits[0]?.patient?.id,this?.Visits[0]?.status)"
      class="btn btn-success" *ngIf="Visits">
      <!-- {{ "goAliveNow" | translate }}  -->
      Go Live Now
    </button>
    <button *ngIf="this.app.isDoctor" class="btn btn-success" (click)="markSlotCompleted(this?.Visits[0]?.id)">
        Mark As Completed
      </button>
  </div>
</div>